import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import { ChoicesComponentFilter } from "@generated"
import { motion } from "framer-motion"
import React from "react"
import * as S from "./elements"

interface Props {
  active: ChoicesComponentFilter
  onSetTab: (component: ChoicesComponentFilter) => void
  allowedTabs: ChoicesComponentFilter[]
}

const motionContainer = {
  show: {
    transition: {
      staggerChildren: 0.5,
    },
  },
}

const motionItem = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
}

const Tabs: React.FC<Props> = ({ active, onSetTab, allowedTabs }) => {
  const { messages } = useIntl()

  return (
    <Box
      display="flex"
      alignItems={["center", "flex-end", "center", "center"]}
      justifyContent="center"
      height="100%"
    >
      <S.TabWrap
        variants={motionContainer}
        initial="hidden"
        animate="show"
        allowedTabs={allowedTabs}
      >
        {allowedTabs.includes(ChoicesComponentFilter.Stone) && (
          <motion.span variants={motionItem}>
            <S.ToggleButton
              variant="purple-border"
              active={active === "stone"}
              onClick={() => onSetTab(ChoicesComponentFilter.Stone)}
            >
              {messages.configurator.stone}
            </S.ToggleButton>
          </motion.span>
        )}

        {allowedTabs.includes(ChoicesComponentFilter.Frame) && (
          <motion.span variants={motionItem}>
            <S.ToggleButton
              variant="purple-border"
              active={active === "frame"}
              onClick={() => onSetTab(ChoicesComponentFilter.Frame)}
            >
              {messages.configurator.frame}
            </S.ToggleButton>
          </motion.span>
        )}
        {allowedTabs.includes(ChoicesComponentFilter.Base) && (
          <motion.span variants={motionItem}>
            <S.ToggleButton
              variant="purple-border"
              active={active === "base"}
              onClick={() => onSetTab(ChoicesComponentFilter.Base)}
            >
              {messages.configurator.base}
            </S.ToggleButton>
          </motion.span>
        )}
      </S.TabWrap>
    </Box>
  )
}

export default Tabs
